export const lineOption = {
  // color: ["#00f2f1", "#525EED", "#56ef78", "#ff9f7f", "#0096ff", "#E60137"],
  legend: {
    data: ["邮件营销", "联盟广告", "视频广告", "直接访问", "搜索引擎"],
    // data: []
  },
  xAxis: [
    {
      type: "category",
      boundaryGap: false,
      data: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
      // data: []
    },
  ],
  yAxis: [
    {
      type: "value",
      axisLabel: {
        formatter: "{value}%",
      },
    },
  ],
  series: [
    {
      name: "邮件营销",
      type: "line",
      stack: "总量",
      data: [120, 132, 101, 134, 90, 230, 210],
      label: {
        show: true,
        position: "top",
        color: "#777777",
      },
    },
  ],
};

export const lineOption1 = {
  color: ["#00f2f1", "#525EED", "#56ef78", "#ff9f7f", "#0096ff", "#E60137"],
  tooltip: {
    trigger: "axis",
    formatter: function (params) {
      let result = params[0].name + "<br>";
      params.forEach(function (item) {
        result +=
          item.marker + " " + item.seriesName + ": " + item.value + "%<br>";
      });
      return result;
    },
  },
  legend: {
    textStyle: {
      color: "#4c9bfd",
    },
  },
  grid: {
    top: "30%",
    left: "1%",
    right: "1%",
    bottom: "10%",
    show: true, // 显示边框
    containLabel: true, // 包含刻度文字在内
  },

  xAxis: [
    {
      type: "category",
      data: [],
      axisTick: {
        alignWithLabel: true,
        show: false, // 去除刻度线
      },
      axisLabel: {
        color: "#606266", // 文本颜色
        formatter: function (value) {
          return "周" + value; // 将数值以“万”为单位展示
        },
      },
      axisLine: {
        show: false, // 去除轴线
      },
    },
  ],
  yAxis: [
    {
      type: "value",
      axisTick: {
        show: false, // 去除刻度线
      },
      axisLabel: {
        color: "#606266", // 文本颜色
        formatter: function (value) {
          return value + "%";
        },
      },
      axisLine: {
        show: false, // 去除轴线
      },
      splitLine: {
        lineStyle: {
          color: "#e9e9e9", // 分割线颜色
        },
      },
    },
  ],
  series: [
    {
      name: "新增",
      type: "line",
      data: [],
    },
  ],
};

export const lineSeries1 = [
  {
    name: "首约及时率",
    code: "timelyAppointmentRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
  {
    name: "首约上门准时率",
    code: "onTimeFirstVisitRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
  {
    name: "安装快准率",
    code: "sameDayCompletionRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
  {
    name: "3天内维修完结率",
    code: "repairWithinThreeDaysRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
  {
    name: "5天内维修完结率",
    code: "repairWithinFiveDaysRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
];

export const lineSeries2 = [
  {
    name: "APP完工率",
    code: "appCompletionRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
  {
    name: "不满意工单占比",
    code: "unsatisfiedOrderRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
  {
    name: "京东安装差评率",
    code: "jdInstallationNegativeReviewRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
  {
    name: "京东售后满意度",
    code: "jdAfterSalesSatisfactionRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
];

export const lineSeries3 = [
  {
    name: "首约及时率",
    code: "timelyAppointmentRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
  {
    name: "首约上门准时率",
    code: "onTimeFirstVisitRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
  {
    name: "安装快准率",
    code: "sameDayCompletionRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
  {
    name: "终约及时率",
    code: "finalAppointmentTimelyRate",
    type: "line",
  },
  {
    name: "3天内维修完结率",
    code: "repairWithinThreeDaysRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
  {
    name: "5天内维修完结率",
    code: "repairWithinFiveDaysRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
  {
    name: "APP完工率",
    code: "appCompletionRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
  {
    name: "京东售后满意度",
    code: "jdAfterSalesSatisfactionRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
];

export const lineSeries4 = [
  {
    name: "不满意工单占比",
    code: "unsatisfiedOrderRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
  {
    name: "京东安装差评率",
    code: "jdInstallationNegativeReviewRate", // 对应 IndicatorDTO 中的字段
    type: "line",
  },
];
